import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TopbarComponent }  from '../topbar/topbar.component';
import { ToastModule }      from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { IdleService } from '../../../core/auth/idle.service';

/**
 * Shell principal: topbar + <router-outlet>
 * Todas las rutas protegidas renderizan aquí.
 */
@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [
    CommonModule, RouterOutlet,
    TopbarComponent,
    ToastModule, ConfirmDialogModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="shell-root topbar-only">
      <app-topbar />

      <main class="shell-content">
        <div class="shell-page">
          <router-outlet />
        </div>
      </main>
    </div>

    <!-- Toast y Confirm dialog globales -->
    <p-toast position="bottom-right" [life]="4000" />
    <p-confirmDialog />
  `
})
export class ShellComponent implements OnInit, OnDestroy {
  private readonly idleService = inject(IdleService);

  ngOnInit(): void {
    this.idleService.startWatching();
  }

  ngOnDestroy(): void {
    this.idleService.stopWatching();
  }
}
